import ResponsiveModel from "../../responsive/ResponsiveModel.js";
const TYPE = 'molten.dataViewers.pieChart.PieChartViewModel';
function create(model = null) {
  return {
    ...ResponsiveModel.create(model),
    type: TYPE
  };
}
export default {
  ...ResponsiveModel,
  TYPE,
  create
};